import * as THREE from "three";
import { Auth } from '../UI/Auth'

export class InputSystem {

  constructor(store) {
    this.store = store;
    this.camera = this.store.enviroment.camera.get();
    this.mouse = new THREE.Vector2();
    this.raycaster = new THREE.Raycaster();
    this.pointerDownX = 0;
    this.pointerDownY = 0;
    this.activePointers = new Set();
    this.hoveredCity = null;
    this.hoveredChartBar = null;
    this.init();
  }

init() {

  window.addEventListener("pointerdown", (event) => {
    this.activePointers.add(event.pointerId);
    this.pointerDownX = event.clientX;
    this.pointerDownY = event.clientY;
    this.isDragging = false;
  });

  window.addEventListener("pointermove", (event) => {
    const dx = event.clientX - this.pointerDownX;
    const dy = event.clientY - this.pointerDownY;
    if (Math.sqrt(dx * dx + dy * dy) > 10) {this.isDragging = true;}
    this.handleHover(event);
  });

  window.addEventListener("pointerup", (event) => {
    const wasMultiTouch = this.activePointers.size > 1;
    this.activePointers.delete(event.pointerId);
    if (wasMultiTouch) {return;}
    if (this.isDragging) {return;}
    this.handleClick(event);
  });

  window.addEventListener("pointercancel", (event) => {this.activePointers.delete(event.pointerId);});
}

  
handleHover(event) {
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    this.raycaster.setFromCamera(this.mouse, this.camera);
    const intersects = this.raycaster.intersectObjects(this.store.input.clickables, true).filter(hit => {
        let obj = hit.object;
        while (obj) {
            if (obj.userData?.ignoreRaycast) return false;
            obj = obj.parent;
        }
        return true;
    });
    let city = null;
    let chartBar = null;
    for (const intersect of intersects) {
        let hitObject = intersect.object;
        while (hitObject) {
            const type = hitObject.userData?.type;
            if (type === "CITY") {
                city = hitObject.userData.instance;
                break;
            }
            if (type === "CHART_BAR") {
                chartBar = hitObject.userData.instance;
                break;
            }
            hitObject = hitObject.parent;
        }
        if (city || chartBar) break;
    }

    // CITY hover kezelése
    if (city !== this.hoveredCity) {
        if (this.hoveredCity) {this.hoveredCity.setHover(false);}
        if (city) {city.setHover(true);}
        this.hoveredCity = city;
    }

    // CHART_BAR hover kezelése
  if (chartBar !== this.hoveredChartBar) {
      if (this.hoveredChartBar) {
          this.hoveredChartBar.setHover(false);
      }
      if (chartBar) {chartBar.setHover(true);}
      this.hoveredChartBar = chartBar;
  }
}


  async handleClick(event) {
    // Modal kezelése
    if (this.store.level.modalOpen && this.store.modalController.modal.contains(event.target)) {return;}
    // Egér normalizálása
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    // Raycaster
    this.raycaster.setFromCamera(this.mouse, this.camera);
      const intersects = this.raycaster.intersectObjects(this.store.input.clickables, true).filter(hit => {
          let obj = hit.object;
          while (obj) {
              if (obj.userData?.ignoreRaycast) return false;
              obj = obj.parent;
          }
          return true;
    });
    if (!intersects.length) {return;}
    
    let hitObject = intersects[0].object;
    //console.log('HIT OBJECT:', hitObject.name, hitObject.uuid, hitObject.userData, 'parent:', hitObject.parent?.name, hitObject.parent?.userData);
    //AUTH
    if (this.store.database.actualUser === null) {
      if (!this.store.auth) {
        this.store.auth = new Auth(this.store);
        this.store.level.auth = true;
      }
    }
    
    // Megkeressük a megfelelő szülőobjektumot
    while (hitObject) {
        const type = hitObject.userData?.type;
        if (
            type === "CITY" ||
            type === "OFFICES" ||
            type === "PLUS" ||
            type === "magnifier" ||
            type === "pendrive" ||
            type === "otheroffice" ||
            type === "colleague" ||
            type === "office" ||
            type === "map" ||
            type === "JOB_SWITCH" ||
            type === "AUTH" ||
            type === "chart"
        ) {
            break;
        }
        hitObject = hitObject.parent;
    }

    if (!hitObject) {return;}
    //console.log("HIT TYPE:", hitObject.userData?.type);
    switch (hitObject.userData?.type) {
      case "CITY": {
        const city = await this.store.datas.findOne("CITIES", "name", hitObject.userData.instance.label);
        // BÚTOR MOZGATÁSA
        if (this.store.level.move && this.store.database.deviceToMove?.type === "FURNITURE") {
            this.store.database.moveTo = city;
            this.store.events.dispatchEvent(new CustomEvent("moveTargetSelected", {detail: city})
            );
        } else {
            this.store.level.selectedCity = city;
            this.store.modalController.setLayout({layout: "MODALOPEN", component: "CITYDETAILS", data: city});
        }
        break;}
      case "OFFICES": {
        this.store.levelController.setLevel({name: "OFFICES", hit: hitObject.userData});
        break;}
      case "PLUS": {
        this.store.levelController.setLevel({name: "PLUS", hit: hitObject.userData});
        break;}
      case "magnifier": {
        this.store.levelController.setLevel({name: "SEARCH", hit: hitObject.userData});
        break;}
      case "pendrive": {
        this.store.levelController.setLevel({name: "CSVEXPORT", hit: hitObject.userData});
        break;}
      case "otheroffice": {
        this.store.level.selectedOffice = hitObject.userData.instance;
        this.store.levelController.setLevel({name: "OTHEROFFICE", hit: hitObject.userData});
        break;}
      case "colleague": {
        const colleague = hitObject.userData.instance;
        // ESZKÖZMOZGATÁS
        if (this.store.level.move && this.store.database.deviceToMove?.type === "IT") {
            this.store.database.moveTo = await this.store.datas.findOne("USERS", "id", colleague.id);
            this.store.events.dispatchEvent(new CustomEvent("moveTargetSelected", {detail: colleague}));
            break;
        }
        // KOLLÉGA HOZZÁADÁSA TELEPÜLÉSHEZ
        if (this.store.level.cityuser) {
            //await this.store.cities.onCityChange(colleague);
            await this.store.cityUserController.onCityChange(colleague);
            break;
        }
        // NORMÁL KOLLÉGA
        this.store.level.selectedColleague = colleague;
        this.store.levelController.setLevel({name: "COLLEAGUE", colleague, office: null, position: colleague.getWorldPosition()});
        break;}
      case "office": {
        const office = hitObject.userData.instance;
        // BÚTOR MOZGATÁSA
        if (this.store.level.move && this.store.database.deviceToMove?.type === "FURNITURE") {
            this.store.database.moveTo = await this.store.datas.findOne("CITIES", "name", office.label);
            this.store.events.dispatchEvent(new CustomEvent("moveTargetSelected", {detail: office}));
            break;
        }
        // NORMÁL OFFICE
        this.store.level.selectedOffice = office;
        this.store.levelController.setLevel({name: "OFFICE", office, position: office.getWorldPosition()});
        break;}
      case "map": {
        this.store.level.itDevices = [];
        this.store.level.otherDevices = [];
        this.store.levelController.setLevel({name: "MAP", office: null, position: hitObject.userData.instance.getWorldPosition()});
        break;}
      case "JOB_SWITCH": {
        this.store.levelController.setLevel({name: "JOB_SWITCH", hit: hitObject.userData});
        break;}
      case "chart": {
        this.store.modalController.setLayout({layout: "MODALOPEN", component: "CHART", data: null});
        break;}
    }
  }
}